import { dayjs } from '../../libs/day';

export interface ICalendayDay {
  date: dayjs.Dayjs;
  dayOfMonth: number;
  isCurrentMonth: boolean;
}

export enum EDatePickerModifiedDate {
  START = 'start',
  END = 'end',
}
